/* eslint-disable prettier/prettier */
const enviroment = {
	firebaseConfig: {
		apiKey: 'AIzaSyC893ljzQ1k8SusqCUJYdakl8rqws8B4x8',
		authDomain: 'recluchat-b4d94.firebaseapp.com',
		projectId: 'recluchat-b4d94',
		storageBucket: 'recluchat-b4d94.appspot.com',
		messagingSenderId: '1033365316603',
		appId: '1:1033365316603:web:19c8a2adfc7148551fa15e',
		measurementId: '${config.measurementId}'
	},
	// cloudFunctions: 'http://localhost:5001/recluchat-b4d94/us-central1'
	cloudFunctions: 'https://us-central1-recluchat-b4d94.cloudfunctions.net/'
};

export default enviroment;